import Cookies from 'js-cookie/src/js.cookie'

export { Cookies }
